import axios from "axios";
import api from "../../../utils/api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { Status } from "../../../@types/status";
import axiosInstance from "../../../utils/axiosConfig";

export const findStatus = createAsyncThunk(
  "utils/findStatus",
  async (props, { rejectWithValue, getState }) => {
    try {
      const { data } = await axiosInstance.get(`${api.baseURL}status`, {});

      return data as Status[];
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
